import { ContentEditable as LexicalContentEditable } from "@lexical/react/LexicalContentEditable";

import type { RTEComponentDefs } from "../RichTextEditorProps";

import CSS from "../styles.module.css";

export interface RTEEditorDefs {
  readonly id: string;
  readonly ariaLabel: string | undefined;
  readonly ariaLabelledBy: string | undefined;
  readonly ariaDescribedBy: string | undefined;
  readonly ariaErrorMessage: string | undefined;
  readonly ariaInvalid: boolean;
  readonly ariaRequired: boolean | undefined;
  readonly ariaDisabled: boolean;
  readonly ariaReadOnly: boolean;
  readonly ariaBusy: boolean;
  readonly tabIndex?: number;
  readonly placeholder?: string;
}

export const Editor: RTEComponentDefs<RTEEditorDefs> = ({ id, tabIndex, placeholder, ...aria }) => {
  const placeholderNode = placeholder ? (
    <span className={CSS.Placeholder} aria-hidden="true">
      {placeholder}
    </span>
  ) : (
    <></>
  );

  return (
    <LexicalContentEditable
      aria-busy={aria.ariaBusy || undefined}
      aria-describedby={aria.ariaDescribedBy}
      aria-disabled={aria.ariaDisabled || undefined}
      aria-errormessage={aria.ariaErrorMessage}
      aria-invalid={aria.ariaInvalid || undefined}
      aria-label={aria.ariaLabel}
      aria-labelledby={aria.ariaLabelledBy}
      aria-placeholder={placeholder ?? ""}
      aria-readonly={aria.ariaReadOnly || undefined}
      aria-required={aria.ariaRequired}
      className={CSS.ContentEditable}
      id={id}
      placeholder={placeholderNode}
      tabIndex={tabIndex}
    />
  );
};
